"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isActionError;

var _fluxStandardAction = require("flux-standard-action");

var _isApiError = _interopRequireDefault(require("./is-api-error"));

function isActionError(action) {
  return (0, _isApiError.default)(action) || (0, _fluxStandardAction.isFSA)(action) && (0, _fluxStandardAction.isError)(action);
}